import React, { useMemo } from 'react';
import styles from './StanProgressBar.module.css';
import type { StanProgressBarProps } from './StanProgressBar.types';

export const StanProgressBar: React.FC<StanProgressBarProps> = ({
    min = 0,
    max = 100,
    value,
    progressColor = 'var(--color-brand-main)',
    barColor = 'var(--color-neutral-subtle)',
    className = '',
}) => {
    const barWidth = useMemo(() => {
        const percentage = Math.max(0, Math.min(100, (100 * (value - min)) / (max - min)));
        return isNaN(percentage) ? 0 : percentage;
    }, [value, min, max]);

    return (
        <div
            className={`${styles.progressContainer} ${className}`}
            style={{ backgroundColor: barColor }}
            role='progressbar'
            aria-valuenow={value}
            aria-valuemin={min}
            aria-valuemax={max}
        >
            <div
                className={styles.progressBar}
                style={{
                    width: `${barWidth}%`,
                    backgroundColor: progressColor,
                }}
            />
        </div>
    );
};
